exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dpsraion-component{border:0;font-size:10pt}h3.h3{color:#cc7108;font-family:trebuchet MS,Helvetica,sans-serif;font-size:11pt;text-transform:uppercase;font-weight:400;line-height:1em;border-bottom:1px solid #ededed;padding-bottom:14px;margin-bottom:17px}.dataTable{width:100%;border:1px solid grey;font-size:10pt;border-spacing:0}.dataTable td,th{border:1px solid grey;padding:5px}.png1{float:left;margin:5px;border:1px solid gray;padding:3px}.strOnline{padding-top:15px}.pOfline{clear:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/DpsRaion.css
// module id = 140
// module chunks = 0